import styled from "styled-components";

import { Grid, Panel } from "react-bootstrap";
import { CtaButton } from "../Common/index.style";

export const Container = styled(Grid)`
  display: grid;
  place-content: center;
`;

export const SignUpPanel = styled(Panel)`
  margin-top: 2rem;
  max-width: 700px;
`;

export const SignUpButton = styled(CtaButton)`
  width: 200px;
  height: 50px;
  margin-right: 3rem;
`;

export const LoginLink = styled.div`
  margin: 1rem 0 1rem 0;
  flex: auto;
`;

export const FooterContainer = styled(Grid)`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  max-width: 700px;
`;
